import { GoogleLoginProvider } from 'angular-6-social-login';
import { ToastDefaults } from 'ng-snotify';
import { Config } from './config/config';
import { AuthServiceConfig } from 'angular-6-social-login';
import { getSaver } from './component/all-video-cms-listing/saver.provider';
const firebase = {
    apiKey: "AIzaSyBumzsxvlvggiyx7JRGJnP_8k37C8vK4OU",
    authDomain: "blankpaper-notifications.firebaseapp.com",
    projectId: "blankpaper-notifications",
    storageBucket: "blankpaper-notifications.appspot.com",
    messagingSenderId: "712653993784",
    appId: "1:712653993784:web:fc0101f8426a6b8c36f3cd",
    measurementId: "G-2E0GNSZ2Z6"
};
const ɵ0 = GoogleLoginProvider.PROVIDER_ID;
const login_config = new AuthServiceConfig([
    {
        id: ɵ0,
        provider: new GoogleLoginProvider('59036276639-9ufea2catbasbmb6mmjn7kdsgpma6edn.apps.googleusercontent.com')
    },
]);
export function provideConfig() {
    return login_config;
}
const configFilePath = '';
export function configProviderFactory(provider) {
    return () => provider.load(configFilePath);
}
const ɵ1 = ToastDefaults, ɵ2 = getSaver;
export class AppModule {
}
export { ɵ0, ɵ1, ɵ2 };
// platformBrowserDynamic().bootstrapModule(AppModule);
